// 9MILLY - keeps the Shopify Inbox chat launcher dark liquid glass,
// matching the "9MILLY ACCESS" teaser (assets/chat-widget-glass.css),
// WITHOUT darkening the opened conversation panel.
//
// The closed launcher button and the opened conversation panel are
// actually the SAME underlying element tree: both live inside
// <shopify-agent-runtime>, nested INSIDE <shopify-chat>'s own shadow
// root (confirmed live via the activator button's full ancestor chain).
// Both read --shopify-agent-bg-color/-text-color from whichever ancestor
// declares them nearest - runtime redeclares them on itself (its own
// inline style, once populated), which blocks inheritance from the outer
// <shopify-chat> regardless of !important.
//
// Two races discovered live, both handled below:
// 1. <shopify-chat>'s own inline style gets (re)written by the app's own
//    startup sequence AFTER this script's first pass, silently reverting
//    an earlier override - so this also watches shopify-chat's own
//    `style` attribute and re-applies on every change, not just once.
// 2. <shopify-agent-runtime> doesn't reliably carry the color variables
//    from the very first paint - they get populated (or rewritten)
//    later, and again on every open/close.
//
// A first cut forced runtime's variables dark unconditionally, which
// also darkened the OPENED panel - and broke it, because the panel's
// other text/surface colors (headings, body copy, product cards) are NOT
// all wired to these same two variables, so large parts of the open
// panel ended up dark-on-dark and unreadable. Confirmed live this can't
// be split into "one set for the pill, another for the panel" - it's the
// exact same property on the exact same element either way. Fix: track
// <shopify-chat>'s `open` attribute (confirmed live it's set/removed as
// the panel opens/closes) and swap which colors get forced accordingly -
// dark while closed, the app's own real defaults while open.
(function () {
  var DARK_BG = 'rgba(18, 18, 18, 0.82)';
  var DARK_TEXT = '#ffffff';
  // The app's own defaults, captured live from shopify-chat's inline
  // style before any override was ever applied.
  var OPEN_BG = '#ffffff';
  var OPEN_TEXT = '#000000';

  var watchedRuntime = null;
  var watchedChat = null;

  // Only write when the value actually needs to change - both the chat-
  // level and runtime-level observers below watch the exact attribute
  // this function writes to, so an unconditional write on every call
  // would re-trigger its own observer every time (each write is a real
  // attribute mutation even when the string ends up identical, since
  // setProperty re-serializes the whole style attribute). Guarding on
  // the current value makes each observer fire at most once per actual
  // state change instead of looping.
  function setIfChanged(el, prop, value) {
    if (el.style.getPropertyValue(prop) !== value) {
      el.style.setProperty(prop, value, 'important');
    }
  }

  function resync(chat) {
    if (!chat) return;
    var isOpen = chat.hasAttribute('open');

    // Keep shopify-chat itself dark at all times - this is what the
    // closed launcher inherits from before shopify-agent-runtime exists/
    // populates its own values, and what it falls back to if runtime's
    // own override is ever cleared.
    setIfChanged(chat, '--shopify-agent-bg-color', DARK_BG);
    setIfChanged(chat, '--shopify-agent-text-color', DARK_TEXT);

    var runtime = chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
    if (!runtime) return;

    if (runtime !== watchedRuntime) {
      watchedRuntime = runtime;
      new MutationObserver(function () {
        resync(chat);
      }).observe(runtime, { attributes: true, attributeFilter: ['style'] });
    }

    if (isOpen) {
      setIfChanged(runtime, '--shopify-agent-bg-color', OPEN_BG);
      setIfChanged(runtime, '--shopify-agent-text-color', OPEN_TEXT);
    } else {
      setIfChanged(runtime, '--shopify-agent-bg-color', DARK_BG);
      setIfChanged(runtime, '--shopify-agent-text-color', DARK_TEXT);
    }
  }

  function watchChat(chat) {
    if (chat === watchedChat) return;
    watchedChat = chat;
    resync(chat);
    new MutationObserver(function () {
      resync(chat);
    }).observe(chat, { attributes: true, attributeFilter: ['style', 'open'] });
  }

  function trySetup() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return false;

    watchChat(chat);

    if (!chat.shadowRoot) return false;

    new MutationObserver(function () {
      resync(chat);
    }).observe(chat.shadowRoot, { childList: true, subtree: true });

    return true;
  }

  function init() {
    if (!trySetup()) {
      window.setTimeout(init, 300);
    }
  }

  // Redundant safety net: independently re-check/resync for the first
  // ~15s after load, in case some path (e.g. an ancestor being replaced
  // outright instead of mutated, or a style rewrite this specific
  // combination of observers doesn't catch) slips past everything above.
  var pollCount = 0;
  var pollId = window.setInterval(function () {
    var chat = document.querySelector('shopify-chat');
    if (chat) {
      watchChat(chat);
      resync(chat);
    }
    pollCount++;
    if (pollCount > 40) window.clearInterval(pollId);
  }, 400);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
